import { Component, inject, signal, TemplateRef, WritableSignal } from '@angular/core';
import { NgbDatepickerModule, NgbOffcanvas, NgbOffcanvasRef, OffcanvasDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { IconsComponent } from 'src/app/shared/components/icons/icons.component';

interface SidebarOffcanvasContext {
  navItems?: string[];
  selectedDate?: string;
}

@Component({
  selector: 'app-sidebar',
	imports: [NgbDatepickerModule, IconsComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly offcanvasService = inject(NgbOffcanvas);
	closeResult: WritableSignal<string> = signal('');

	open(content: TemplateRef<SidebarOffcanvasContext>): void {
		this.offcanvasService.open(content, { ariaLabelledBy: 'offcanvas-basic-title' }).result.then(
			(result) => {
				this.closeResult.set(`Closed with: ${result}`);
			},
			(error_) => {
				this.closeResult.set(`Dismissed ${this.getDismissReason(error_)}`);
			},
		);
	}

	private getDismissReason(reason: OffcanvasDismissReasons | string): string {
		switch (reason) {
			case OffcanvasDismissReasons.ESC:
				return 'by pressing ESC';
			case OffcanvasDismissReasons.BACKDROP_CLICK:
				return 'by clicking on the backdrop';
			default:
				return `with: ${reason}`;
		}
	}

	handleClick(event: Event, offcanvas: NgbOffcanvasRef): void {
		const target = event.target as HTMLElement;
		// Traverse up to find a clickable nav link
		const link = target.closest('a.nav-link');
		if (link) {
		  offcanvas.dismiss('Navigated via menu');
		}
	  }
}

